(function (window) {
  "use strict";

  var managedVideos = new Set();

  function register(video) {
    if (video) managedVideos.add(video);
  }

  function unregister(video) {
    if (!video) return;
    video.pause();
    managedVideos.delete(video);
  }

  function requestPlay(video) {
    if (!video) return null;
    if (!video.isConnected) {
      unregister(video);
      return null;
    }
    register(video);

    managedVideos.forEach(function (candidate) {
      if (!candidate.isConnected) {
        candidate.pause();
        managedVideos.delete(candidate);
        return;
      }
      if (candidate !== video) candidate.pause();
    });

    if (!video.paused) return null;
    var playAttempt = video.play();
    if (playAttempt && typeof playAttempt.catch === "function") {
      playAttempt.catch(function () {
        // Keep the poster when browser autoplay policy rejects playback.
      });
    }
    return playAttempt;
  }

  window.MarlotVideoPlaybackCoordinator = {
    register: register,
    unregister: unregister,
    requestPlay: requestPlay
  };
})(window);
